import {
    FETCH_GST_INIT_ACTION,
    FETCH_GST_SUCCESS_ACTION,
    FETCH_GST_FAIL_ACTION,
    ADD_GST_SUCCESS_ACTION,
    UPDATE_GST_STATUS_SUCCESS_ACTION,
    EDIT_GST_SUCCESS_ACTION,
    GST_SELECTED_PAGE_ACTION,
} from "./action";

const initialState = {
    gstList: [],
    gstCount: 0,
    loading: false,
    error: null,
    gstSelectedPage: 1,
};

export default function GstMasterReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_GST_INIT_ACTION:
            return {
                ...state,
                loading: true,
            };
        case FETCH_GST_SUCCESS_ACTION:
            return {
                ...state,
                loading: false,
                gstList: action.payload.rows,
                gstCount: action.payload.count,
            };
        case FETCH_GST_FAIL_ACTION:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case ADD_GST_SUCCESS_ACTION:
            return {
                ...state,
                loading: false,
            };
        case UPDATE_GST_STATUS_SUCCESS_ACTION:
            return {
                ...state,
                loading: false,
            };
        case EDIT_GST_SUCCESS_ACTION:
            return {
                ...state,
                loading: false,
            };
        case GST_SELECTED_PAGE_ACTION:
            return {
                ...state,
                gstSelectedPage: action.value,
            };
        default:
            return state;
    }
}
